import { render, staticRenderFns } from "./ModuleIconWithBadge.vue?vue&type=template&id=cb3ca50a&"
import script from "./ModuleIconWithBadge.vue?vue&type=script&lang=js&"
export * from "./ModuleIconWithBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports